import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { NewOrganisationModalEnum } from 'enums/organisationMapEnums';
import { MetaData } from 'models/MetaData/metaData.model';
import { OrganizationDetails } from 'models/OrganizationDetails/organizationDetails.model';
import { convertToOptionsGeneric } from 'shared/utils/convertOptions';
import {
  baselineYearList,
  monthList,
  orgBoundaryOptions,
} from 'views/CompanySetup/companySetupConstants';
import { getAppendedName } from './addNewOrganisation.utls';

const {
  NAME_FIELD,
  SECTOR_FIELD_NAME,
  SIZE_FIELD_NAME,
  ORGANISATIONAL_BOUNDARY_FIELD_NAME,
  ORGANIZATION_SHARE,
  RECALCULATION_THRESHOLD,
  REPORTING_MONTH,
  BASELINE_YEAR,
  COMPANY_TYPE_FIELD_NAME,
} = NewOrganisationModalEnum;

export const getNewOrganisationFields = (props: {
  sizeMetaData: MetaData[];
  sectorMetaData: MetaData[];
  companyTypesMeta: MetaData[];
  isMainParent?: boolean;
  data?: OrganizationDetails;
  handleToolTipOpen?: (fieldName?: HelpDeskInputFieldEnum) => () => void;
}) => {
  const {
    sizeMetaData,
    sectorMetaData,
    companyTypesMeta,
    isMainParent,
    data,
    handleToolTipOpen,
  } = props;
  const {
    organizationName,
    organizationSize,
    organizationSector,
    organizationCompanyType,
    organizationBoundary,
    reportingDetailsYear,
    reportingDetailsBaselineYear,
    reportingDetailsThreshold,
  } = HelpDeskInputFieldEnum;

  return {
    ORGANISATION_NAME: {
      NAME: getAppendedName(NAME_FIELD, data),
      PLACEHOLDER: 'Organization name',
      LABEL: 'Organization name',
      INFO: true,
      INFO_HANDLER: handleToolTipOpen?.(organizationName),
    },
    DROPDOWNS: [
      {
        key: SIZE_FIELD_NAME,
        NAME: getAppendedName(SIZE_FIELD_NAME, data),
        PLACEHOLDER: 'Select Organization size',
        LABEL: 'Organization size',
        OPTIONS: convertToOptionsGeneric<number>(sizeMetaData),
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(organizationSize),
      },
      {
        key: COMPANY_TYPE_FIELD_NAME,
        NAME: getAppendedName(COMPANY_TYPE_FIELD_NAME, data),
        PLACEHOLDER: 'Select Company Type',
        LABEL: 'Company Type',
        OPTIONS: convertToOptionsGeneric<number>(companyTypesMeta),
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(organizationCompanyType),
      },
      {
        key: SECTOR_FIELD_NAME,
        NAME: getAppendedName(SECTOR_FIELD_NAME, data),
        PLACEHOLDER: 'Select Sector',
        LABEL: 'Sector',
        OPTIONS: convertToOptionsGeneric<number>(sectorMetaData),
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(organizationSector),
      },
      {
        key: ORGANISATIONAL_BOUNDARY_FIELD_NAME,
        NAME: ORGANISATIONAL_BOUNDARY_FIELD_NAME,
        PLACEHOLDER: 'Select Organizational Boundary',
        LABEL: 'Organizational Boundary',
        OPTIONS: orgBoundaryOptions,
        HIDDEN: !isMainParent,
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(organizationBoundary),
      },
    ],
    ORGANISATION_BOUNDARY: {
      NAME: getAppendedName(ORGANIZATION_SHARE, data),
      PLACEHOLDER: 'Enter Organizational Boundary (%)',
      LABEL: 'Organizational Boundary (%)',
      HIDDEN: !!isMainParent,
      INFO: true,
      INFO_HANDLER: handleToolTipOpen?.(organizationBoundary),
    },
    REPORTING_DETAILS: [
      {
        NAME: REPORTING_MONTH,
        PLACEHOLDER: 'Start of reporting year',
        LABEL: 'Start of your reporting year',
        DISABLED: true,
        OPTIONS: monthList,
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(reportingDetailsYear),
      },
      {
        NAME: BASELINE_YEAR,
        PLACEHOLDER: 'Baseline year',
        LABEL: 'Baseline year',
        DISABLED: true,
        OPTIONS: baselineYearList,
        INFO: true,
        INFO_HANDLER: handleToolTipOpen?.(reportingDetailsBaselineYear),
      },
    ],
    REPORTING_DETAIL_BASELINE_THRESHOLD: {
      NAME: RECALCULATION_THRESHOLD,
      PLACEHOLDER: 'Enter Baseline year Recalculation Threshold (%)',
      LABEL: 'Baseline year Recalculation Threshold (%)',
      INFO: true,
      INFO_HANDLER: handleToolTipOpen?.(reportingDetailsThreshold),
    },
  };
};
